var map = {
	"./en/2-1/rewards.png": 11141,
	"./fi/2-1/rewards.png": 94751,
	"./in/2-1/rewards.png": 28265,
	"./th/2-1/rewards.png": 14140,
	"./tw/2-1/rewards.png": 44155,
	"./wap/en/2-1/rewards.png": 63306,
	"./wap/fi/2-1/rewards.png": 17180,
	"./wap/in/2-1/rewards.png": 16454,
	"./wap/th/2-1/rewards.png": 77835,
	"./wap/tw/2-1/rewards.png": 28300,
	"./wap/zh/2-1/rewards.png": 22141,
	"./zh/2-1/rewards.png": 70166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92369;